@if (swiper) {
<div [style.--swiper-dots-number]="bullets.length">
    <div class="swiper-dots-inner"
         aria-label="Carousel Pagination">
        @for (bullet of bullets; track $index; let i = $index) {
        <button class="swiper-dot"
                [class.is-active]="index === i"
                type="button"
                [attr.aria-label]="'Carousel Page ' + (i + 1) + (index === i ? ' (Current Slide)' : '')"
                (mouseenter)="slideTo(i)"></button>
        }
        <div class="swiper-dots-underbar"></div>
    </div>
</div>
}